import { SIDEBAR_NAV_GROUP_COOKIE_NAME } from '../ci/sidebar-nav-cookie';

/**
 * The sidebar open-state cookie contract, shared by the client provider that
 * WRITES it and the server layouts that READ it back (PAY-2791).
 *
 * This module deliberately carries **no `'use client'` directive**, and that is
 * the whole reason it exists rather than living in `sidebar.tsx`.
 *
 * `sidebar.tsx` is a client module. When a server component imports a value
 * from one, Next.js replaces the export with an opaque client reference — so
 * `cookieStore.get(SIDEBAR_COOKIE_NAME)` receives a *function* instead of the
 * string, silently returns `undefined`, and the layout falls back to its
 * default. TypeScript still sees `string`, so nothing fails to compile and no
 * unit test notices; the sidebar just never restores its state.
 *
 * Keep these constants here. Importing the cookie name from `@ci/ui/sidebar`
 * into a server component reintroduces exactly that bug.
 */

/** Cookie the provider writes as `sidebar_state=true|false`. */
export const SIDEBAR_COOKIE_NAME = 'sidebar_state';

/** Seven days, matching the shadcn default. */
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;

/**
 * Forget both sidebar cookies on sign-out so the next signed-in user does not
 * inherit the previous user's layout.
 */
export function clearSidebarPreferences() {
  if (typeof document === 'undefined') return;

  for (const name of [SIDEBAR_COOKIE_NAME, SIDEBAR_NAV_GROUP_COOKIE_NAME]) {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
  }
}
